import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      takeaways={[
        
        { text: "Concentrate more on periodic and odd,even function fourier series for CAT-2" },
        
        
      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummary;
